import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  addAssignCubesMachinOperatorsToGraders,
  getUserByRoleId,
  updateAssignCubesMachinOperatorsToGraders,
} from "api";

class MacOperatorAssignCube extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      props: props?.location?.query,
      boilManList: [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    const boilMan = await getUserByRoleId("ROLE0000005");
    this.setState({
      boilManList: boilMan.data.users,
    });
  }

  async handleSubmit(values) {
    // e.preventDefault();
    if (this.state.props.isEdit == 1) {
      values.machineOperatorStockId = this.state.props.data.id;
      values.graderUserId = this.state.props.data.graderStock.user.id;
      delete values.partyCode;
      delete values.cubeId;
      delete values.cycle;
      delete values.graderName;
      const data = await addAssignCubesMachinOperatorsToGraders(values);
      this.state.history.push("/assign-cube-list");
    } else {;
      let id = this.state.props.data.id;
      values.id = id;
      values.machineOperatorStockId =
        this.state.props.data.machineOperatorStockId;
      values.graderUserId = this.state.props.data.graderStock.user.id;
      delete values.partyCode;
      delete values.cubeId;
      delete values.cycle;
      delete values.graderName;
      delete values.fillerNotes;
      const data = await updateAssignCubesMachinOperatorsToGraders(values);
      this.state.history.push("/assign-cube-list");
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "machine operator flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Assign Belt" />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        cubeId:
                          this.state.props.isEdit == 2
                            ? this.state.props.data
                                .assignCubesFillerToMachinOperator?.stockFillerInWard?.cubeId
                            : this.state.props.data
                                .assignCubesFillerToMachinOperator?.stockFillerInWard?.cubeId,
                        partyCode:
                          this.state.props.isEdit == 1
                            ? this.state.props.data.stock.party.partyCode
                            : this.state.props.data.stock.party.partyCode,
                        boilManUserId:
                          this.state.props.isEdit == 1
                            ? ""
                            : this.state.props.data.user.id,
                        cycle:
                          this.state.props.isEdit == 1
                            ? this.state.props.data.assignGraderToFillerStock
                                ?.cycle
                            : this.state.props.data.assignGraderToFillerStock
                                ?.cycle,
                        graderName:
                          this.state.props.isEdit == 1
                            ? this.state.props.data.graderStock?.user.name
                            : this.state.props.data.graderStock?.user.name,
                        fillerNotes:
                          this.state.props.isEdit == 1
                            ? this.state.props.data.fillerNotes
                            : this.state.props.data.fillerNotes,
                      }}
                      validationSchema={Yup.object().shape({
                        cubeId: Yup.string().notRequired(),
                        partyCode: Yup.string().notRequired(),
                        boilManUserId: Yup.string().required(
                          "This Value is Required"
                        ),
                        cycle: Yup.string().notRequired(),
                        graderName: Yup.string().notRequired(),
                        fillerNotes: Yup.string().notRequired(),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values, validateForm }) => (
                        <Form className="needs-validation">
                          <div className="d-lg-flex d-block justify-content-between">
                            <div>
                              <h4 className="pb-3 text-black fw-bold">
                                Assign Belt
                              </h4>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="date"
                                className="col-12 col-sm-2 col-lg-5"
                              >
                                <h5 className="fs-5 fw-bold text-black">
                                  Assign Date:
                                </h5>
                              </Label>
                              <div className="col-12 col-sm-5 col-lg-7">
                                <Field
                                  className={
                                    "border-0 fs-5" +
                                    (errors.date && touched.date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="date"
                                  name="date"
                                />
                                <ErrorMessage
                                  name="date"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="cubeId"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                Belt ID
                              </h5>
                            </Label>
                            <div className="col-md-10 col-12">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.cubeId && touched.cubeId
                                    ? " is-invalid"
                                    : "")
                                }
                                name="cubeId"
                                type="text"
                                readOnly={true}
                              ></Field>
                              <ErrorMessage
                                name="cubeId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="partyCode"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('Party Code')}
                              </h5>
                            </Label>
                            <div className="col-md-10 col-12">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.partyCode && touched.partyCode
                                    ? " is-invalid"
                                    : "")
                                }
                                name="partyCode"
                                placeholder="Party 1"
                              />
                              <ErrorMessage
                                name="partyCode"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="boilManUserId"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                              {this.props.t("Boil Man Name")}
                              </h5>
                            </Label>
                            <div className="col-md-10 col-12">
                              <Field
                                disabled={
                                  this.state.props.isEdit == 3 ? true : false
                                }
                                className={
                                  "form-control form-select fs-5" +
                                  (errors.boilManUserId && touched.boilManUserId
                                    ? " is-invalid"
                                    : "")
                                }
                                name="boilManUserId"
                                as="select"
                              >
                                <option value="" disabled>
                                  select
                                </option>
                                {this.state.boilManList?.map(x => (
                                  <option key={x.id} value={x.id}>
                                    {x.name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="boilMan"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="cycle"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('Cycle No.')}
                              </h5>
                            </Label>
                            <div className="col-md-10 col-12">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.cycle && touched.cycle
                                    ? " is-invalid"
                                    : "")
                                }
                                name="cycle"
                                placeholder="cycle"
                                readOnly={true}
                              />
                              <ErrorMessage
                                name="cycle"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="graderName"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t("Grader Name")}
                              </h5>
                            </Label>
                            <div className="col-md-10 col-12">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.graderName && touched.graderName
                                    ? " is-invalid"
                                    : "")
                                }
                                name="graderName"
                                type="text"
                                readOnly={true}
                              ></Field>
                              <ErrorMessage
                                name="graderName"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="fillerNotes"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t('Filler Notes')}
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.fillerNotes && touched.fillerNotes
                                    ? " is-invalid"
                                    : "")
                                }
                                type="text"
                                name="fillerNotes"
                                as="textarea"
                                rows="5"
                                readOnly={true}
                              />
                              <ErrorMessage
                                name="fillerNotes"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="col-md-12 text-center text-md-end mt-4">
                          {this.state.props.isEdit == 3 ? <Button
                              color="primary"
                              type="submit"
                              className="fs-4 px-5"
                              onClick={() => {
                               this.state.history.goBack()
                              }}
                            >
                             Back
                            </Button> : <Button
                              color="primary"
                              type="submit"
                              className="fs-4 px-5"
                              onClick={() => {
                                validateForm()
                                  .then(data => {
                                    if (Object.keys(data).length == 0) {
                                      this.handleSubmit(values);
                                    }
                                  })
                                  .catch(err => console.log(err));
                              }}
                            >
                              Assign
                            </Button> }
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default MacOperatorAssignCube;
